import { Inject, Injectable } from '@angular/core';
import { WindowExt } from '@core/app/app.module.helpers';


@Injectable({
    providedIn: 'root',
})
export class ParkingGuard {
    public constructor(@Inject('window') private window: WindowExt) {
    }

    public canLoad(): Promise<boolean> | boolean {
        return new Promise((resolve) => {
            if (this.window.appSettings.enableParking !== 'Y') {
                resolve(false);
            } else {
                resolve(true);
            }
        });
    }
}
